import styled from "styled-components";

const ButtonEdit = styled.button`
  font-size: 1.2rem;
  padding: 0.4rem 0.8rem;
  font-weight: 600;
  text-align: center;
  color: var(--color-grey-600);
  background: var(--color-grey-0);
  border: 1px solid var(--color-grey-200);
  border-radius: 5px;

  &:hover {
    background-color: var(--color-grey-200);
  }
`;

export default ButtonEdit;
